<template>
  <div class="ios-glass-page">
    <!-- 1. 背景装饰 (光斑动画) -->
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
    </div>

    <!-- 2. 页面头部 -->
    <!-- <div class="page-header">
      <h2 class="header-title">电源控制中心</h2>
      <div class="header-subtitle">Power & Schedule Control</div>
    </div> -->

    <!-- 3. 卡片一：快捷控制 -->
    <div class="glass-card">
      <div class="card-title-row">
        <span class="card-title">设备状态与控制</span>
        <span class="refresh-btn" @click="getList()">
          <i class="el-icon-refresh"></i> 刷新
        </span>
      </div>

      <!-- 设备列表 (替代原 el-table) -->
      <div class="device-list">
        <div v-for="item in deviceList" :key="item.id" class="device-item">
          <div class="device-info">
            <div class="device-icon">
              <van-icon name="desktop-o" />
            </div>
            <span class="device-name">{{ item.corxName }}</span>
          </div>
          <div class="device-status">
            <!-- 状态标签 -->
            <span 
              class="status-badge"
              :class="{
                'on': +item.corxStatus == 1 && +item.corxStatus == +item.corxUpStatus,
                'off': +item.corxStatus == 0 && +item.corxStatus == +item.corxUpStatus,
                'pending': +item.corxStatus != +item.corxUpStatus
              }"
            >
              {{ getStatusText(item) }}
            </span>
          </div>
        </div>
      </div>

      <!-- 快捷按钮组 -->
      <div class="action-group">
        <div class="glass-btn btn-on" @click="confirmBatchPowerOn">
          <van-icon name="play-circle-o" class="btn-icon"/> 全部开机
        </div>
        <div class="glass-btn btn-off" @click="confirmBatchPowerOff">
          <van-icon name="pause-circle-o" class="btn-icon"/> 全部关机
        </div>
      </div>

      <div class="tips-box">
        <van-icon name="info-o" /> 操作后请等待2分钟更新状态，且今日定时将失效。
      </div>
    </div>

    <!-- 4. 卡片二：定时设置 -->
    <div class="glass-card" style="margin-top: 20px;">
      <div class="card-title-row">
        <span class="card-title">定时任务设置</span>
      </div>

      <div class="form-content">
        <!-- 设备选择 -->
        <div class="form-group">
          <label class="form-label">选择设备</label>
          <el-select
            v-model="selectedTimerDevice"
            placeholder="请选择要设置的项目"
            size="medium"
            style="width: 100%;"
            class="glass-select"
            value-key="id"
            @change="deviceListSelectionChange"
          >
            <el-option
              v-for="item in deviceList"
              :key="item.id"
              :label="item.corxName"
              :value="item"
            />
          </el-select>
        </div>

        <!-- 星期选择 (胶囊样式) -->
        <div class="form-group">
          <label class="form-label">重复周期</label>
          <div class="week-selector">
            <div 
              v-for="day in weekOptions" 
              :key="day.value"
              class="week-pill"
              :class="{ active: weekCheckList.includes(day.value) }"
              @click="toggleWeek(day.value)"
            >
              {{ day.label }}
            </div>
          </div>
        </div>

        <!-- 时间段列表 -->
        <div class="time-ranges">
          <label class="form-label">开关机时间</label>
          <!-- <transition-group name="list"> -->
            <div v-for="(item, idx) in timerSettings.timeRanges" :key="idx" class="time-row-glass">
              <div class="time-inputs">
                <div class="time-col">
                  <span class="sub-label">开机</span>
                  <el-time-picker
                    v-model="item.startTime"
                    placeholder="00:00"
                    class="glass-time-picker"
                    :clearable="false"
                    size="small"
                    format="HH:mm"
                    value-format="HH:mm"
                  />
                </div>
                <div class="time-divider"><van-icon name="arrow" /></div>
                <div class="time-col">
                  <span class="sub-label">关机</span>
                  <el-time-picker
                    v-model="item.endTime"
                    placeholder="00:00"
                    class="glass-time-picker"
                    :clearable="false"
                    size="small"
                    format="HH:mm"
                    value-format="HH:mm"
                  />
                </div>
              </div>
              <div class="row-action" v-if="timerSettings.timeRanges.length > 1" @click="removeTimeRange(idx)">
                <van-icon name="delete-o" color="#ff3b30" size="20" />
              </div>
            </div>
          <!-- </transition-group> -->
        </div>

        <!-- 底部操作 -->
        <div class="form-actions">
          <div class="add-btn" @click="addTimeRange">
            <van-icon name="plus" /> 添加时段
          </div>
          <el-button
            class="save-btn"
            type="primary"
            round
            @click="confirmSetTimer"
          >保存定时设置</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { getFlowableSchoolCorxInfoList, save, saveToo, getFlowableSchoolCorxInfoTimeList } from "@/api/teacher/powerSwitch.js";
import moment from 'moment';

export default {
  name: 'PowerSwitchGlass',
  data() {
    return {
      teacherTitleInfo: {},
      deviceList: [],
      selectedTimerDevice: null, // 修正初始化
      selectedDevicesObj: {},
      timerSettings: {
        timeRanges: [{ startTime: '', endTime: '' }]
      },
      weekCheckList: [],
      // 星期配置项
      weekOptions: [
        { label: '一', value: '1' },
        { label: '二', value: '2' },
        { label: '三', value: '3' },
        { label: '四', value: '4' },
        { label: '五', value: '5' },
        { label: '六', value: '6' },
        { label: '日', value: '7' },
      ]
    };
  },
  mounted() {
    try {
      this.teacherTitleInfo = JSON.parse(sessionStorage.getItem('teacherTitleInfo') || '{}');
      this.getList();
    } catch (e) { console.error(e) }
  },
  methods: {
    // 获取状态文案
    getStatusText(item) {
      if (+item.corxStatus != +item.corxUpStatus) return '进行中...';
      return +item.corxStatus == 1 ? '开启' : '关闭';
    },
    // 切换星期
    toggleWeek(val) {
      const index = this.weekCheckList.indexOf(val);
      if (index > -1) {
        this.weekCheckList.splice(index, 1);
      } else {
        this.weekCheckList.push(val);
      }
      // 保持顺序
      this.weekCheckList.sort();
    },

    getList() {
      getFlowableSchoolCorxInfoList({
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
      }).then(res => {
        this.deviceList = res.data.body || [];
      });
    },

    saveToo(openOrClose) {
      saveToo({
        isCover: 1,
        mqttMode: 0,
        openOrClose: openOrClose,
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
      }).then(res => {
        Dialog.alert({
          title: '指令已发送',
          message: '请耐心等待约2分钟，设备状态将会更新。',
          theme: 'round-button',
        }).then(() => {
          this.getList();
        });
      });
    },

    confirmBatchPowerOn() {
      Dialog.confirm({
        title: '确认开机',
        message: '确定要开启所有项目设备吗？',
      }).then(() => {
        this.saveToo(1);
      }).catch(() => {});
    },

    confirmBatchPowerOff() {
      Dialog.confirm({
        title: '确认关机',
        message: '确定要关闭所有项目设备吗？',
      }).then(() => {
        this.saveToo(0);
      }).catch(() => {});
    },

    confirmSetTimer() {
      if (!this.selectedTimerDevice) {
        this.$toast('请先选择一个设备');
        return;
      }
      const valid = this.timerSettings.timeRanges.some(
        t => t.startTime && t.endTime
      );
      if (!valid) {
        this.$toast('请至少完善一个有效的时间段');
        return;
      }
      Dialog.confirm({
        title: '保存设置',
        message: '确定要更新该设备的定时任务吗？',
      }).then(() => {
        this.save();
      }).catch(() => {});
    },

    deviceListSelectionChange(val) {
      this.selectedDevicesObj = val;
      // 重置数据
      this.weekCheckList = [];
      this.timerSettings.timeRanges = [{ startTime: '', endTime: '' }];

      getFlowableSchoolCorxInfoTimeList({ corxCode: val.corxCode }).then(res => {
        if (res.data.body && res.data.body.length > 0) {
          const weekSet = new Set();
          const timeRangeMap = new Map();
          
          res.data.body.forEach(item => {
            if (item.week) {
              if (Array.isArray(item.week)) {
                item.week.forEach(w => weekSet.add(String(w)));
              } else {
                weekSet.add(String(item.week));
              }
            }
            const startTime = item.startTime ? moment(item.startTime, ['HH:mm', 'HH:mm:ss']).format('HH:mm') : '';
            const endTime = item.endTime ? moment(item.endTime, ['HH:mm', 'HH:mm:ss']).format('HH:mm') : '';
            const key = `${startTime}-${endTime}`;
            
            if (startTime && endTime && !timeRangeMap.has(key)) {
              timeRangeMap.set(key, { startTime, endTime });
            }
          });
          
          this.weekCheckList = Array.from(weekSet).sort();
          if (timeRangeMap.size > 0) {
            this.timerSettings.timeRanges = Array.from(timeRangeMap.values());
          }
        }
      });
    },

    save() {
      let flowableSchoolCorxTimeList = [];
      if (this.timerSettings.timeRanges.length > 0) {
        this.timerSettings.timeRanges.forEach((item) => {
          flowableSchoolCorxTimeList.push({
            id: this.selectedDevicesObj.id,
            corxCode: this.selectedDevicesObj.corxCode,
            weeks: this.weekCheckList,
            startTime: item.startTime,
            endTime: item.endTime,
          });
        });
      }

      let data = {
        isCover: 1,
        mqttMode: 1,
        deviceId: this.selectedTimerDevice.id, // 注意这里可能需要传ID或Code，视后端而定，原代码是传了整个对象给v-model，这里取id
        timeRanges: this.timerSettings.timeRanges,
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
        flowableSchoolCorxTimeVoList: flowableSchoolCorxTimeList,
        deleteSchoolCorxTimeList: [],
      };

      save(data).then(res => {
        this.$notify({ type: "success", message: '设置保存成功' });
        // 清空表单或保持，视需求而定，原代码是清空
        this.timerSettings.timeRanges = [{ startTime: '', endTime: '' }];
        this.selectedTimerDevice = null;
        this.weekCheckList = [];
      });
    },

    addTimeRange() {
      this.timerSettings.timeRanges.push({ startTime: '', endTime: '' });
    },
    removeTimeRange(idx) {
      this.timerSettings.timeRanges.splice(idx, 1);
    },
  },
};
</script>

<style lang="less" scoped>
/* ----------------- 全局容器 ----------------- */
.ios-glass-page {
  min-height: 100vh;
  width: 100%;
  /* 柔和的浅灰蓝渐变背景，营造高级感 */
  background: radial-gradient(circle at top left, #f1f3f9, #dfe4ea);
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", Helvetica, Arial, sans-serif;
  padding: 20px;
  box-sizing: border-box;
  color: #1c1c1e;
  overflow-y: auto;
}

/* 动态背景光斑 */
.background-blobs {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  .blob { position: absolute; border-radius: 50%; filter: blur(60px); opacity: 0.5; }
  .blob-1 { width: 250px; height: 250px; background: #cce0ff; top: -50px; left: -50px; animation: float 8s ease-in-out infinite; }
  .blob-2 { width: 200px; height: 200px; background: #e0f2f1; top: 40%; right: -50px; animation: float 10s ease-in-out infinite reverse; }
}
@keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(20px); } }

/* 头部 */
.page-header {
  position: relative; z-index: 1; margin-bottom: 24px; padding-left: 4px;
  .header-title { font-size: 28px; font-weight: 800; margin: 0; letter-spacing: -0.5px; }
  .header-subtitle { font-size: 14px; color: #8e8e93; font-weight: 500; margin-top: 4px; }
}

/* ----------------- 毛玻璃卡片通用样式 ----------------- */
.glass-card {
  position: relative; z-index: 1;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);
  padding: 20px;
  margin-bottom: 24px;
}

.card-title-row {
  display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;
  .card-title { font-size: 17px; font-weight: 600; color: #1c1c1e; }
  .refresh-btn { font-size: 13px; color: #007AFF; cursor: pointer; display: flex; align-items: center; gap: 4px; }
}

/* ----------------- 设备列表样式 ----------------- */
.device-list {
  display: flex; flex-direction: column; gap: 12px; margin-bottom: 20px;
}

.device-item {
  display: flex; justify-content: space-between; align-items: center;
  background: rgba(255,255,255,0.5);
  padding: 12px 16px;
  border-radius: 16px;
  
  .device-info {
    display: flex; align-items: center; gap: 12px;
    .device-icon {
      width: 36px; height: 36px; background: #fff; border-radius: 10px;
      display: flex; align-items: center; justify-content: center;
      color: #007AFF; font-size: 20px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    }
    .device-name { font-size: 15px; font-weight: 500; }
  }

  .status-badge {
    font-size: 12px; padding: 4px 10px; border-radius: 20px; font-weight: 600;
    &.on { background: #34C759; color: #fff; box-shadow: 0 2px 8px rgba(52, 199, 89, 0.3); }
    &.off { background: #8e8e93; color: #fff; }
    &.pending { background: #FF9500; color: #fff; }
  }
}

/* ----------------- 快捷按钮组 ----------------- */
.action-group {
  display: flex; gap: 16px; margin-bottom: 16px;
  .glass-btn {
    flex: 1; height: 50px;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    border-radius: 16px; font-size: 15px; font-weight: 600; cursor: pointer;
    transition: transform 0.1s;
    &:active { transform: scale(0.98); }
    
    &.btn-on {
      background: linear-gradient(135deg, #007AFF, #0056b3);
      color: #fff;
      box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);
    }
    &.btn-off {
      background: rgba(255, 255, 255, 0.8);
      color: #ff3b30;
      border: 1px solid rgba(255, 59, 48, 0.1);
    }
    .btn-icon { font-size: 18px; }
  }
}

.tips-box {
  font-size: 12px; color: #8e8e93; background: rgba(0,0,0,0.03);
  padding: 10px; border-radius: 12px; display: flex; align-items: center; gap: 6px;
}

/* ----------------- 定时表单样式 ----------------- */
.form-content {
  display: flex; flex-direction: column; gap: 16px;
}

.form-group {
  .form-label { display: block; font-size: 13px; color: #8e8e93; margin-bottom: 8px; margin-left: 4px; }
}

/* 穿透修改 Element UI Select */
::v-deep .glass-select .el-input__inner {
  background-color: rgba(255, 255, 255, 0.5) !important;
  border: 1px solid rgba(0,0,0,0.05) !important;
  border-radius: 12px !important;
  height: 44px;
  color: #1c1c1e;
}

/* 星期胶囊 */
.week-selector {
  display: flex; justify-content: space-between;
  background: rgba(255,255,255,0.4); padding: 4px; border-radius: 14px;
  .week-pill {
    width: 36px; height: 36px;
    display: flex; align-items: center; justify-content: center;
    border-radius: 10px; font-size: 14px; color: #8e8e93; font-weight: 500;
    transition: all 0.2s; cursor: pointer;
    
    &.active {
      background: #007AFF; color: #fff;
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);
    }
  }
}

/* 时间段列表 */
.time-ranges {
  .form-label { font-size: 13px; color: #8e8e93; margin-bottom: 8px; margin-left: 4px; display: block; }
}

.time-row-glass {
  display: flex; align-items: center; justify-content: space-between;
  background: rgba(255,255,255,0.5); padding: 12px; border-radius: 16px;
  margin-bottom: 10px;
  border: 1px solid rgba(255,255,255,0.6);
  
  .time-inputs {
    flex: 1; display: flex; align-items: center; gap: 10px;
    .time-col {
      flex: 1; display: flex; flex-direction: column; gap: 4px;
      .sub-label { font-size: 10px; color: #aaa; padding-left: 4px; }
    }
    .time-divider { color: #ccc; padding-top: 14px; }
  }
  
  .row-action {
     padding: 8px; cursor: pointer; opacity: 0.8;
    &:active { opacity: 0.5; }
  }
}
  ::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 140px;
  // background-color: rgba(255, 255, 255, 0.6) !important;
  // border: 1px solid rgba(0,0,0,0.1) !important;
  border-radius: 8px !important;
  text-align: center;
  height: 32px;
  line-height: 32px;
  padding: 0;
}
/* 穿透修改 Time Picker */
::v-deep .glass-time-picker .el-input__inner {
  background: transparent !important;
  border: none !important;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #1c1c1e;
  padding: 0;
  height: 30px;
    width: 140px;
}
::v-deep .glass-time-picker .el-input__prefix { display: none; }

/* 底部按钮 */
.form-actions {
  margin-top: 10px;
  .add-btn {
    text-align: center; color: #007AFF; font-size: 14px; padding: 10px;
    margin-bottom: 12px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 4px;
  }
  .save-btn {
    width: 100%; height: 48px; font-size: 16px; font-weight: 600;
    background: linear-gradient(135deg, #007AFF, #5856D6);
    border: none;
    box-shadow: 0 4px 16px rgba(0, 122, 255, 0.25);
  }
}

/* 列表动画 */
.list-enter-active, .list-leave-active { transition: all 0.3s; }
.list-enter, .list-leave-to { opacity: 0; transform: translateY(-10px); }
</style>